/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsacceptancerate2Inputs */

const en_statsacceptancerate2 = /** @type {(inputs: Statsacceptancerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptance rate`)
};

const de_statsacceptancerate2 = /** @type {(inputs: Statsacceptancerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annahmequote`)
};

/**
* | output |
* | --- |
* | "Acceptance rate" |
*
* @param {Statsacceptancerate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsacceptancerate2 = /** @type {((inputs?: Statsacceptancerate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsacceptancerate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsacceptancerate2(inputs)
	return de_statsacceptancerate2(inputs)
});
export { statsacceptancerate2 as "statsAcceptanceRate" }